import { useRecoilState } from 'recoil';
import homeState from '../../atoms/home';
import messagesState from '../../atoms/messages';
import participantsState from '../../atoms/participants';
import './HomeHeader.scoped.scss';
import emitCleanRoom from '../../connector/emits/cleanRoom';
import myInfoState from '../../atoms/myinfo';

function HomeHeader() {
  const [myInfo] = useRecoilState(myInfoState);
  const [home, setHome] = useRecoilState(homeState);
  const [messages, setMessages] = useRecoilState(messagesState);

  const [participants] = useRecoilState(participantsState);

  return (
    <div>
      <div className="home-header">
        <i className="home-header__icon-people"></i>
        <span className="home-header__participants">👪{participants.users.length}명</span>
        <ul className="home-header__buttons">
          <li>
            <button 
              className="home-header__button home-header__button--open-popup" 
              onClick={() => window.open('/chatting-app', 'Chatting App', 'width=500,height=600')} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--up-font-size" 
              onClick={() => setHome({...home, fontSize: home.fontSize + 1})} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--down-font-size" 
              onClick={() => setHome({...home, fontSize: home.fontSize === 10 ? 10 : home.fontSize - 1})} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--clear-chatting" 
              onClick={() => {
                if (myInfo.id === 'admin') {
                  emitCleanRoom();
                } else {
                  setMessages({
                    ...messages,
                    messages: []
                  });
                }
              }} 
            />
          </li>
          <li>
            <button 
              className="home-header__button home-header__button--refresh" 
              onClick={() => window.location.reload()} 
            />
          </li>
        </ul>
      </div>
    </div>
  );
}

export default HomeHeader;